import { html } from "common-tags"

export function parseJupyter(
  description: string,
  _tabTrigger: string,
  snippet: string
) {
  const separatedSnippet = snippet
    .replace(/\\(?![btnr])/g, "\\\\")
    .replace(/"/g, '\\"')
    .split("\n")
  const separatedSnippetLength = separatedSnippet.length

  const newSnippet = separatedSnippet.map((line, index) => {
    return index === separatedSnippetLength - 1 ? `"${line}"` : `"${line}",`
  })

  const name = description || "snippet"

  return html`
    { "snippets": [ { "name": "${name}", "code": [ ${newSnippet.join("\n")} ] }
    ] }
  `
}
